module.exports = __webpack_public_path__ + "assets/img/5_1218_big.c55b5ace.jpg";